import { render, staticRenderFns } from "./BudgetPage.vue?vue&type=template&id=13e7a9aa&"
import script from "./BudgetPage.vue?vue&type=script&lang=js&"
export * from "./BudgetPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports